import { getConfig } from '@/lib/flags';
// Used to easily differentiate custom events from default events in Google Analytics
export const EVENT_PREFIX = 'ff';

const flags = getConfig();

const bucketed: Record<string, string> = {};
Object.entries(flags).flatMap((cfg) => {
  const [name, c] = cfg;

  return c.variants.map((variant) => {
    const key = `user_bucketed.${name}.${variant}`;
    bucketed[key] = key;
  });
});

export const EVENT_NAMES: Record<string, string> = {
  ...bucketed,
  attachment_expansion_toggle_click: 'attachment_expansion_toggle_click',
  back_to_top_click: 'back_to_top_click',
  collapsible_section_toggled: 'collapsible_section_toggled',
  contact_form_submission: 'contact_form_submission',
  external_link_click: 'external_link_click',
  feed_item_share_click: 'feed_item_share_click',
  feed_item_favorite_click: 'feed_item_favorite_click',
  footer_click: 'footer_click',
  findings_feed_expand_media_toggle: 'findings_feed_expand_media_toggle',
  findings_feed_filters_toggled: 'findings_feed_filters_toggled',
  findings_feed_load_more: 'findings_feed_load_more',
  full_writeup_opened: 'full_writeup_opened',
  home_hero_shuffle: 'home_hero_shuffle',
  home_hero_topic_click: 'home_hero_topic_click',
  jumplink_click: 'jumplink_click',
  newsletter_signup: 'newsletter_signup',
  opened_mobile_menu: 'opened_mobile_menu',
  originals_sidebar_item_click: 'originals_sidebar_item_click',
  random_topic_button_click: 'random_topic_button_click',
  resource_explorer_facet_clicked: 'resource_explorer_facet_clicked',
  resource_explorer_facets_show_more_clicked:
    'resource_explorer_facets_show_more_clicked',
  resource_explorer_filter_closed: 'resource_explorer_filter_closed',
  resource_explorer_filter_opened: 'resource_explorer_filter_opened',
  resource_explorer_searched: 'resource_explorer_searched',
  search_dropdown_topic_click: 'search_dropdown_topic_click',
  site_nav_dropdown_opened: 'site_nav_dropdown_opened',
  site_nav_search_form_submit: 'site_nav_search_form_submit',
  site_nav_topic_click: 'site_nav_topic_click',
  social_share_click: 'social_share_click',
  subscription_complete: 'subscriptionComplete', // TODO: consolidate
  subscriptionComplete: 'subscriptionComplete',
  subscription_complete_preferences: 'subscription_complete_preferences',
  subscription_complete_join_more: 'subscription_complete_join_more',
  topic_card_click: 'topic_card_click',
  topic_overview_expanded: 'topic_overview_expanded',
  truncated_list_toggled: 'truncated_list_toggled',
  truncated_overview_toggled: 'truncated_overview_toggled',
  truncation_container_collapsed: 'truncation_container_collapsed',
  truncation_container_expanded: 'truncation_container_expanded',
  video_complete: 'video_complete',
  video_cta_click: 'video_cta_click',
  video_playlist_item_autoplay: 'video_playlist_item_autoplay',
  video_playlist_item_click: 'video_playlist_item_click',
  video_progress: 'video_progress',
  video_start: 'video_start',
} as const;

export type SiteSearchListContextType =
  | 'recently-viewed'
  | 'popular-topics'
  | 'goto-search'
  | 'topics-matching';
